module.exports = __webpack_public_path__ + "static/media/ancorBg.e59b59bf.jpg";